var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMinusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 2,
    viewBox: "0 0 10 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44443 1.00003C9.44443 1.49095 9.04646 1.88892 8.55554 1.88892L1.44443 1.88892C0.953511 1.88892 0.555542 1.49095 0.555542 1.00003C0.555542 0.509107 0.953512 0.111138 1.44443 0.111138L8.55554 0.111138C9.04646 0.111138 9.44443 0.509107 9.44443 1.00003Z",
    fill: "#773DBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMinusBlue);
export default __webpack_public_path__ + "static/media/ic_minus_blue.71d74d8c5ad51ee4dd4b6bea51b8d078.svg";
export { ForwardRef as ReactComponent };